import { createMuiTheme } from '@material-ui/core/styles';

export const DecentureTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#284D82'
    }
  }
});
